import {
  Building2,
  ArrowLeftRight,
  Briefcase,
  BookOpen,
  Users,
  FolderOpen,
  Mail,
  BarChart3,
  FileText,
  PieChart,
  Newspaper,
  ClipboardList,
  CreditCard,
  FileBarChart,
  FileCheck,
  Globe,
  Landmark,
  Calculator,
  Wallet,
  Network,
  History,
  type LucideIcon,
} from 'lucide-react';

interface EntityNavGrandchild {
  value: string;
  label: string;
}

interface EntityNavChild {
  value: string;
  label: string;
  children?: EntityNavGrandchild[];
}

export interface EntityNavItem {
  value: string;
  label: string;
  icon: LucideIcon;
  children?: EntityNavChild[];
}

export const fundNavItems: EntityNavItem[] = [
  {
    value: 'overview',
    label: 'Overview',
    icon: Building2,
  },
  {
    value: 'transactions',
    label: 'Transactions',
    icon: ArrowLeftRight,
    children: [
      { value: 'all', label: 'All Transactions' },
      {
        value: 'drawdowns',
        label: 'Drawdowns',
        children: [
          { value: 'list', label: 'Drawdowns' },
          { value: 'overdue', label: 'Overdue Items' },
          { value: 'prepayment', label: 'Prepayments' },
        ],
      },
      { value: 'distributions', label: 'Distributions' },
      { value: 'convertibles', label: 'Convertibles' },
      {
        value: 'fees-and-costs',
        label: 'Fees & Costs',
        children: [
          { value: 'fee-accruals', label: 'Fee Accruals' },
          { value: 'management-fees', label: 'Management Fees' },
          { value: 'fund-costs', label: 'Fund Costs' },
          { value: 'deal-costs', label: 'Deal Costs' },
        ],
      },
      { value: 'currency-conversions', label: 'Currency Conversions' },
      { value: 'gl-reference', label: 'Ledger Reference' },
      {
        value: 'import-bank-transactions',
        label: 'Import Bank Transactions',
      },
    ],
  },
  {
    value: 'companies',
    label: 'Companies',
    icon: Briefcase,
    children: [
      { value: 'portfolio', label: 'Portfolio' },
      { value: 'valuations', label: 'Valuations' },
    ],
  },
  {
    value: 'general-ledger',
    label: 'General Ledger',
    icon: BookOpen,
    children: [
      { value: 'entries', label: 'Entries' },
      { value: 'bank-entries', label: 'Bank Entries' },
      { value: 'incoming-transactions', label: 'Incoming Transactions' },
      { value: 'trial-balance', label: 'Trial Balance' },
      { value: 'capital-accounts', label: 'Capital Accounts' },
      { value: 'statements', label: 'Statements' },
    ],
  },
  {
    value: 'investors',
    label: 'Investors',
    icon: Users,
  },
  {
    value: 'files',
    label: 'Documents',
    icon: FolderOpen,
  },
  {
    value: 'emails',
    label: 'Emails',
    icon: Mail,
  },
  {
    value: 'reports',
    label: 'Reports',
    icon: FileBarChart,
    children: [
      { value: 'list', label: 'Reports' },
      { value: 'templates', label: 'Templates' },
    ],
  },
  {
    value: 'portal',
    label: 'Portal Visibility',
    icon: Globe,
  },
];

export const companyNavItems: EntityNavItem[] = [
  { value: 'overview', label: 'Overview', icon: Building2 },
  { value: 'valuations', label: 'Valuations', icon: BarChart3 },
  { value: 'financials', label: 'Financials', icon: FileText },
  { value: 'transactions', label: 'Transactions', icon: ArrowLeftRight },
  { value: 'captable', label: 'Cap Table', icon: PieChart },
  { value: 'contacts', label: 'Contacts', icon: Users },
  { value: 'news', label: 'News', icon: Newspaper },
  { value: 'documents', label: 'Documents', icon: FolderOpen },
  { value: 'audit', label: 'Audit', icon: ClipboardList },
];

export const investorNavItems: EntityNavItem[] = [
  { value: 'overview', label: 'Overview', icon: Building2 },
  { value: 'profile', label: 'Profile & Entity', icon: FileText },
  { value: 'banking', label: 'Bank Details', icon: CreditCard },
  { value: 'contacts', label: 'Contacts', icon: Users },
  { value: 'documents', label: 'Documents', icon: FolderOpen },
  { value: 'emails', label: 'Emails', icon: Mail },
  { value: 'change-data', label: 'Change Data', icon: FileCheck },
];

export const fundsCarryNavItems: EntityNavItem[] = [
  { value: 'funds', label: 'Funds', icon: Landmark },
  { value: 'members', label: 'Members', icon: Users },
  { value: 'tax-value', label: 'Tax value', icon: Calculator },
  { value: 'payments', label: 'Payments', icon: Wallet },
  { value: 'documents', label: 'Documents', icon: FolderOpen },
  { value: 'structure', label: 'Structure', icon: Network },
  { value: 'activity-log', label: 'Activity log', icon: History },
];
